import Icon, { IconProps } from '@/components/elements/Icon';
import clsx from 'clsx';

export type ArrowLeftProps = IconProps;

/**
 * @component ChartLine
 */
function ArrowLeft({ className, ...rest }: ArrowLeftProps) {
  return (
    <Icon
      viewBox="0 0 24 24"
      className={clsx(`fill-gray-800`, className)}
      {...rest}
    >
      <path d="M17 11.0002H9.40999L12.71 7.71019C12.8983 7.52188 13.0041 7.26649 13.0041 7.00019C13.0041 6.73388 12.8983 6.47849 12.71 6.29019C12.5217 6.10188 12.2663 5.99609 12 5.99609C11.7337 5.99609 11.4783 6.10188 11.29 6.29019L6.28999 11.2902C6.19895 11.3853 6.12758 11.4974 6.07999 11.6202C5.97997 11.8636 5.97997 12.1367 6.07999 12.3802C6.12758 12.5029 6.19895 12.6151 6.28999 12.7102L11.29 17.7102C11.383 17.8039 11.4936 17.8783 11.6154 17.9291C11.7373 17.9798 11.868 18.006 12 18.006C12.132 18.006 12.2627 17.9798 12.3846 17.9291C12.5064 17.8783 12.617 17.8039 12.71 17.7102C12.8037 17.6172 12.8781 17.5066 12.9289 17.3848C12.9796 17.2629 13.0058 17.1322 13.0058 17.0002C13.0058 16.8682 12.9796 16.7375 12.9289 16.6156C12.8781 16.4937 12.8037 16.3831 12.71 16.2902L9.40999 13.0002H17C17.2652 13.0002 17.5196 12.8948 17.7071 12.7073C17.8946 12.5198 18 12.2654 18 12.0002C18 11.735 17.8946 11.4806 17.7071 11.2931C17.5196 11.1055 17.2652 11.0002 17 11.0002Z" />
    </Icon>
  );
}

export default ArrowLeft;
